import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { NavController } from '@ionic/angular';
import { DbService } from 'src/services/db.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-video-pop',
  templateUrl: './video-pop.component.html',
  styleUrls: ['./video-pop.component.scss'],
})
export class VideoPopComponent implements OnInit {
  //test 가짜데이터
  videoCard = [
    {
      from: '전라북도 유성구',
      to: '전라북도 유성구',
      movingDate: '2020년 3월 15일',
      moveType: '가정',
      photoType: '사진',
    },
  ];
  order$;
  orderId;

  title: string = '';
  constructor(
    public dialogRef: MatDialogRef<VideoPopComponent>,
    public navc: NavController,
    public db: DbService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.title = this.data.title;
    this.orderId = this.data.id;
    this.order$ = this.db.doc$(`order/${this.orderId}`).pipe(
      map(data => {
        const category = data.category;
        if (category) {
          data.category = data.category.replace('이사', '');
        }

        return data;
      })
    );
  }

  ngOnInit() {}

  //팝업 닫기
  closePop(): void {
    this.dialogRef.close();
  }

  //페이지 이동
  gotoOrder(name) {
    this.dialogRef.close({ data: name, check: 'ok' });
  }
}
